/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_SearchInputs */

const en_recipes_search = /** @type {(inputs: Recipes_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search recipes`)
};

const de_recipes_search = /** @type {(inputs: Recipes_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezepte durchsuchen`)
};

/**
* | output |
* | --- |
* | "Search recipes" |
*
* @param {Recipes_SearchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_search = /** @type {((inputs?: Recipes_SearchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_SearchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_search(inputs)
	return en_recipes_search(inputs)
});